import { linkToEditClassAssignment } from "../../routes/teacher/routes/class/routes/edit-assignment/links";

export function linkToEditAssignmentJourney(
  classId?: string,
  assignmentId?: string
) {
  return linkToEditClassAssignment(classId, assignmentId);
}

export function linkToEditAssignmentJourneyDetailsPage(
  classId?: string,
  assignmentId?: string
) {
  return `${linkToEditAssignmentJourney(classId, assignmentId)}/details`;
}

export function linkToEditAssignmentJourneyExamQuestions(
  classId?: string,
  assignmentId?: string
) {
  return `${linkToEditAssignmentJourney(classId, assignmentId)}/exam-questions`;
}

export function linkToEditAssignmentInviteParentsPage(
  classId?: string,
  assignmentId?: string
) {
  return `${linkToEditAssignmentJourney(classId, assignmentId)}/invite-parents`;
}
